import React, { Component } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getDoctorsFull, deleteDoctor } from './../../logic/settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clearStorage } from './../../libs/general';

// Wrapper to provide navigate function to class component
function DoctorsListWithRouter(props) {
  const navigate = useNavigate();
  return <DoctorsList {...props} navigate={navigate} />;
}

class DoctorsList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			doctorsList: [],
			isLoading: true,
			error: null
		};
	}
	
	componentDidMount = async () => {
		try {
			// Get doctor list data
			const doctorsList = await getDoctorsFull();
			this.setState({
				doctorsList,
				isLoading: false
			});
		} catch (e) {
			console.error('Error loading doctors list:', e);
			this.setState({ 
				doctorsList: [],
				isLoading: false, 
				error: e.message || 'Failed to load doctors list'
			});
		}
	}
	
	handleDelete = async (docId) => {
		if (window.confirm('Are you sure you want to delete this doctor?')) {
			try {
				await deleteDoctor(docId);
				clearStorage();
				const doctorsList = this.state.doctorsList.filter((doc) => doc.docId !== docId);
				this.setState({ doctorsList });
			} catch (e) {
				console.error('Error deleting doctor:', e);
				this.setState({ error: 'Failed to delete doctor' });
			}
		}
	}
	
	handleUpdate = (doc) => {
		try {
			const { navigate } = this.props;
			if (!navigate) {
				console.error('Navigation function not available');
				this.setState({ error: 'Navigation error - please refresh the page' });
				return;
			}
			
			doc.firstName = doc.name.firstName;
			doc.lastName = doc.name.lastName;
			doc.mobileNumber = doc.mobile.mobileNumber;
			navigate(`/settings/doctors/${doc.docId}`, { state: { doc } });
		} catch (e) {
			console.error('Navigation error:', e);
			this.setState({ error: 'Failed to navigate - please refresh the page' });
		}
	}
	
	handleSchedule = (doc) => {
		try {
			const { navigate } = this.props;
			if (!navigate) {
				console.error('Navigation function not available');
				this.setState({ error: 'Navigation error - please refresh the page' });
				return;
			}
			navigate(`/settings/doctors/${doc.docId}/schedule`, { state: { doc } });
		} catch (e) {
			console.error('Navigation error:', e);
			this.setState({ error: 'Failed to navigate - please refresh the page' });
		}
	}
	
	handleAlerts = (doc) => {
		try {
			const { navigate } = this.props;
			if (!navigate) {
				console.error('Navigation function not available');
				this.setState({ error: 'Navigation error - please refresh the page' });
				return;
			}
			navigate(`/settings/doctors/${doc.docId}/alerts`, { state: { doc } });
		} catch (e) {
			console.error('Navigation error:', e);
			this.setState({ error: 'Failed to navigate - please refresh the page' });
		}
	}
	
	handleFields = (doc) => {
		try {
			const { navigate } = this.props;
			if (!navigate) {
				console.error('Navigation function not available');
				this.setState({ error: 'Navigation error - please refresh the page' });
				return;
			}
			navigate(`/settings/doctors/${doc.docId}/fields`, { state: { doc } });
		} catch (e) {
			console.error('Navigation error:', e);
			this.setState({ error: 'Failed to navigate - please refresh the page' });
		}
	}
	
	handleBilling = (doc) => {
		try {
			const { navigate } = this.props;
			if (!navigate) {
				console.error('Navigation function not available');
				this.setState({ error: 'Navigation error - please refresh the page' });
				return;
			}
			navigate(`/settings/doctors/${doc.docId}/billing`, { state: { doc } });
		} catch (e) {
			console.error('Navigation error:', e);
			this.setState({ error: 'Failed to navigate - please refresh the page' });
		}
	}
	
	render() {
		const { doctorsList, isLoading, error } = this.state;
		
		return (
			<div>
				<div className="pages__back-button--container">
					<FontAwesomeIcon className="pages__back-button--icon" icon="chevron-left"></FontAwesomeIcon>
					<Link className="pages__back-button--text" to="/settings">Back</Link>
				</div>
				<header className="pages__header--container centered-text">
					<h1>Doctor List</h1>
				</header>
				
				{error && (
					<div className="alert alert-danger" role="alert">
						{error}
						<button 
							type="button" 
							className="close" 
							onClick={() => this.setState({error: null})}
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
				)}
				
				{isLoading ? (
					<div className="settings__list--loading">Loading doctors...</div>
				) : (
					<div className="settings__list--container">
						{doctorsList.length > 0 ? (
							doctorsList.map((doc, i) => (
								<div className="settings__list--item" key={i}>
									<div className="settings__list--docNameSpeciality">
										<h3 className="settings__list--docName">{doc.title}.&nbsp;{doc.name.lastName},&nbsp;{doc.name.firstName}</h3>
										<h4 className="settings__list--docSpeciality">{doc.speciality}</h4>
									</div>
										<button className="btn btn-primary btn-sm mr-1" onClick={() => this.handleSchedule(doc)}>Schedule</button>
										<button className="btn btn-primary btn-sm mr-1" onClick={() => this.handleAlerts(doc)}>Alerts</button>
										<button className="btn btn-primary btn-sm mr-1" onClick={() => this.handleFields(doc)}>Fields</button>
										<button className="btn btn-primary btn-sm mr-1" onClick={() => this.handleBilling(doc)}>Billing</button>
									<div className="settings__list--actionIcons">
										<FontAwesomeIcon onClick={() => this.handleUpdate(doc)} className="settings__list--update" icon="pencil-alt" />
										<FontAwesomeIcon onClick={() => this.handleDelete(doc.docId)} className="settings__list--delete" icon="trash-alt" />
									</div>
								</div>
							))
						) : (
							<div className="settings__list--empty">No doctors found</div>
						)}
					</div>
				)}
				
				<div className="pages__action-bar--container">
					<Link className="pages__action-bar--item" to="/settings/doctors/new">
						<FontAwesomeIcon icon="plus" />
					</Link>
				</div>
				<div className="large-push"></div>
			</div>
		);
	}
}

export default DoctorsListWithRouter;